import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { BoxArrowLeft } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import authSlice from '../../store/slices/auth.slice';
import { routes } from '../data/routes';

const Sidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch(authSlice.actions.setLogoutState());
  };
  return (
    <div
      style={{
        position: 'sticky',
        top: '1rem',
        height: 'calc(100vh - 4rem)',
      }}
    >
      <Card className="h-100">
        <Card.Body className="d-flex flex-column overflow-auto">
          <div>
            <div className="border-bottom mb-3">
              <img
                src="/img/logo.svg"
                className="w-100 my-3"
                alt="Company logo"
              />
            </div>
            {routes?.map((route) => {
              const isActive = route?.route === window.location.pathname;
              return (
                <div
                  onClick={() => navigate(route?.route)}
                  className={`d-flex align-items-center cursor-pointer px-3 py-2 border-radius ${isActive ? 'bg-primary text-white' : ''}`}
                  key={route?.route}
                >
                  {route?.icon}
                  <h6 className="ms-1">{t(route?.name)}</h6>
                </div>
              );
            })}
          </div>
          <div className="flex-1 d-flex align-items-end h-100">
            <div className="mt-3 w-100 border-top pt-3">
              <Button
                variant="secondary"
                className="w-100"
                onClick={handleLogout}
              >
                <BoxArrowLeft className="me-2" />
                {t('button.logout')}
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
      <span className="text-muted text-center d-block mt-2 fs-12">
        &copy; 2025 | All rights reserved | Developed by{' '}
        <a
          href="https://lzrvc.dev"
          target="_blank"
          rel="noopener noreferrer"
          className={'text-primary'}
        >
          lzrvc.dev
        </a>
      </span>
    </div>
  );
};

export default Sidebar;
